import { APIService } from '../../../lib/api/APIService';

class TaskListAPI extends APIService {
  async getBoard(appId = null) {
    const q = appId ? `?app_id=${encodeURIComponent(appId)}` : '';
    return this.get(`/api/task-list/board${q}`);
  }

  async getTopPriority(appId = null) {
    const q = appId ? `?app_id=${encodeURIComponent(appId)}` : '';
    return this.get(`/api/task-list/top-priority${q}`);
  }

  async updateBoard(boardId, payload) {
    return this.patch(`/api/task-list/board/${boardId}`, payload);
  }

  async createTask(boardId, columnId, title, options = {}) {
    return this.post('/api/task-list/tasks', {
      board_id: boardId,
      column_id: columnId,
      title: title || 'New task',
      is_critical: options.is_critical || false,
      priority: options.priority ?? 0,
    });
  }

  async updateTask(taskId, payload) {
    return this.patch(`/api/task-list/tasks/${taskId}`, payload);
  }

  async deleteTask(taskId) {
    return this.delete(`/api/task-list/tasks/${taskId}`);
  }
}

export const taskListAPI = new TaskListAPI();
